<template>
	<el-card
		:body-style="{
			alignItems: 'center',
			padding: '0 18px'
		}"
		class="music"
		shadow="never"
	>
		<div class="right">
			<span class="text">正确项：</span>
			<div class="option">
				<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
					<path
						d="M14.625 2.25H3.375C2.75368 2.25 2.25 2.75368 2.25 3.375V14.625C2.25 15.2463 2.75368 15.75 3.375 15.75H14.625C15.2463 15.75 15.75 15.2463 15.75 14.625V3.375C15.75 2.75368 15.2463 2.25 14.625 2.25Z"
						stroke="#DCDCDC"
						stroke-linejoin="round"
					/>
					<path d="M9 6V12" stroke="#DCDCDC" stroke-linecap="round" stroke-linejoin="round" />
					<path d="M6 9H12" stroke="#DCDCDC" stroke-linecap="round" stroke-linejoin="round" />
				</svg>
			</div>

			<div v-for="(item, index) in notes[0]" :key="item" :style="{ background: item }" class="option">
				<div class="close" @click="notes[0].splice(index, 1)">
					<i class="el-icon-close"></i>
				</div>
			</div>
		</div>

		<div class="interfere">
			<span class="text">干扰项：</span>
			<div class="option">
				<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
					<path
						d="M14.625 2.25H3.375C2.75368 2.25 2.25 2.75368 2.25 3.375V14.625C2.25 15.2463 2.75368 15.75 3.375 15.75H14.625C15.2463 15.75 15.75 15.2463 15.75 14.625V3.375C15.75 2.75368 15.2463 2.25 14.625 2.25Z"
						stroke="#DCDCDC"
						stroke-linejoin="round"
					/>
					<path d="M9 6V12" stroke="#DCDCDC" stroke-linecap="round" stroke-linejoin="round" />
					<path d="M6 9H12" stroke="#DCDCDC" stroke-linecap="round" stroke-linejoin="round" />
				</svg>
			</div>

			<div v-for="(item, index) in notes[1]" :key="item" :style="{ background: item }" class="option">
				<div class="close" @click="notes[1].splice(index, 1)">
					<i class="el-icon-close"></i>
				</div>
			</div>
		</div>
	</el-card>
</template>

<script>
export default {
	name: 'Music',
	props: {
		note: {
			type: Array,
			default: () => [[], []],
			required: true
		}
	},
	data() {
		return {
			//
		}
	},
	computed: {
		notes: {
			get() {
				return this.note
			},
			set(value) {
				this.$emit('input', value)
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.music {
	border-color: rgba(0, 0, 0, 0.2) !important;
	padding-top: 20px;
}

.option {
	width: 52px;
	height: 52px;
	border-radius: 6px;
	border: 1px solid #d7d7d7;
	cursor: pointer;
	display: flex;
	justify-content: center;
	align-items: center;
	position: relative;
	margin: 7px 10px;
}

.close {
	width: 16px;
	height: 16px;
	background-color: rgb(219, 219, 219);
	position: absolute;
	right: 0;
	top: 0;
	display: flex;
	justify-content: center;
	align-items: center;
	border-radius: 100%;
	transform: translateX(30%) translateY(-30%);
	color: white;
	cursor: pointer;
}
.right,
.interfere {
	margin: 26px 0;
	display: flex;
}

.right {
	margin-top: 40px;
}
.text {
	color: #908f8f;
	font-size: 14px;
	line-height: 28 px;
}
</style>
